/* eslint no-template-curly-in-string: 0 */
import officeDepotLogo from "../../assets/images/office-depot-logo.png";
import officeDepotGiftCard from "../../assets/images/office-depot-logo.png";
import { FLOW_TYPES, PAYMENT_NETWORKS, PAYMENT_STATUSES } from "../../utils/enums";

const css = {
  // ":root": {
  //   "--btn-primary-bg-color": "red",
  //   "--btn-primary-bg-color-hover": "red",
  //   "--btn-primary-font-color": "#fff",
  //   "--btn-primary-font-color-hover": "#fff"
  // },
};

const aboutNetworkFaq = {
  answer: "Office Max Gift Cards are a great choice for everyone from the classroom to the boardroom. Available in multiple denominations, they can be used to purchase thousands of products in stores across North America, by phone at <a href=\"tel:+1-800-463-3768\">1.800.GO.DEPOT</a>, or online anytime at <a href=\"http://www.officemax.com\">officemax.com</a>.<br/><br/>The Office Max gift card is issued by North American Card and Coupon Services, LLC and is redeemable solely for merchandise (which excludes any type of prepaid gift, merchandise, debit or services card) at Office Depot stores, online or by phone. Purchases will be deducted from the card amount until the value of the card reaches zero. This card is not redeemable for cash, except as required by law, and cannot be used as a credit card or account payment. Please safeguard this card and treat it like cash. Your Office Depot register receipt will show the remaining balance on the card. Obtain balance at Office Depot stores, online at <a href=\"http://www.officedepot.com\">www.officedepot.com</a> (<a href=\"http://www.officemax.ca\">www.officemax.ca</a> for Canada) or by calling <a href=\"tel:+1-877-776-5056\">877.776.5056</a>. Must call before using if more than 5 years elapse since funding. No expiration date or service fees apply.",
  question: "About Office Depot®/Office Max® eGiftcard"
};

export const officeDepot = {
  id: PAYMENT_NETWORKS.OFFICE_DEPOT,
  displayName: "Office Depot",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: "Office Depot eGiftCard™",
      tagline: "Use online or in-store",
      description: [
        {
          string: "Immediate funds to buy your favorite",
          type: "div",
        },
        {
          string: "items, gifts, and more",
          type: "div",
        },
      ],
      // btnLabel: "Next",
      logo: officeDepotLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your Office Depot eGiftCard™"
    }
  },
  acceptPayment: {
    css,
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    description: [
      "You have chosen to receive a ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " Office Depot eGiftCard which will be emailed to ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail',
        }
      }
    ],
    imgSrc: officeDepotGiftCard
  },
  paymentComplete: {
    initial: {
      description: [
        "Success! Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail',
          },
        },
        " for details regarding your ",
        {
          string: "Office Depot eGiftCard™",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ". It should arrive soon and will include details for your use.",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt'
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        " with details regarding your ",
        {
          string: "Office Depot eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    imgSrc: officeDepotGiftCard,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        aboutNetworkFaq
      ]
    }
  },
  onHold: {
    imgSrc: officeDepotGiftCard,
    description: 'Your payment selection has been received. In most cases, funds are instantly sent; however in some instances it can take 24 to 48 hours for money to arrive.',
  }
};

export default officeDepot;
